<template>
	<db-row :height="height" class="scroller-wrapper" :id="id" @click="scrollDefaultClick">
		<template v-if="isVert">
			<db-row class="scroller-inner-wrapper" height="auto" style="flex-shrink: 0">
				<db-col height="120" class="pull-down-wrapper" valign="middle" align="center" v-if="pullDown && isVert">
					{{pullDownText}}
				</db-col>
				<db-col class="pullDownRemark" :height="pullHeight" valign="middle" align="center" v-if="pullDown && isVert">
					<db-col class="boxer" height="auto" width="auto">{{pullDownFinishRemark}}</db-col>
				</db-col>
				<slot></slot>
				<db-col height="80" class="pull-up-wrapper" valign="middle" align="center" v-if="pullUp && isVert">
					<db-col class="pull-up-text" valign="middle" align="center">{{pullUpText}}</db-col>
					<db-col :width="pullWidth" class="pullUpRemark" :class="pullUpRemarkClass"></db-col>
				</db-col>
			</db-row>
		</template>
		<template v-else>
			<db-col class="scroller-inner-wrapper" width="auto" style="flex-shrink: 0">
				<slot></slot>
			</db-col>
		</template>
		
		<db-icon @click="top" v-if="showTop" width="80" size="64" height="80" class="scroll-top" icon="arr-up" />
	</db-row>
</template>

<script>
	import BScroll from '@better-scroll/core'
	import LazyObserver from '../../../model/observer/LazyObserver'
	import StickObserver from '../../../model/observer/StickObserver'
	import pullDownModule from '@better-scroll/pull-down'
	import pullUpModule from '@better-scroll/pull-up'

	export default {
		name: 'scroller',
		
		props: {
			pullDown: {
				type: Boolean,
				default: false
			},
			
			pullUp: {
				type: Boolean,
				default: false
			},
			
			preventDefault: {
				type: Boolean,
				default: true
			},
		
			probeType: {
				type: [String, Number],
				default: 2 //仅在手指移动时，无限发射事件
			},
			
			ioConfig: {
				type: Object
			},
			
			showTop: {
				type: Boolean,
				default: false
			},
			
			height: {
				type: [String, Number],
				default: '100%'
			},
			
			dir: {
				type: String,
				default: 'VERT'
			}
		},
		
		data(){
			return {
				io: null,
				stickIo: null,
				targets: [],
				id: 'scroller_' + Math.random(),
				scroller: null,
				pullDownLocker: false,
				pullUpLocker: false,
				pullDownText: '下拉获取最新数据',
				pullUpText: '上拉获取下一页数据',
				pullDownFinishRemark: '数据加载完毕',
				pullUpFinishRemark: '数据加载完毕',
				pullHeight: '0',
				pullWidth: '0',
				pullUpRemarkClass: 'pullUpRemarkRemove'
			}
		},
		
		async mounted(){
			await this.initScroller()
		},
		
		inject: ['registStickContainer'],
		
		provide(){
			const that = this
			return {
				regist(lazyWatcher){
					that.io.observe(lazyWatcher)
					return that.scroller
				},
				
				registStick(watcher){
					that.stickIo.observe(watcher)
					return that.scroller
				},
				
				refresh(){
					that.scroller.refresh()
				}
			}
		},
		
		computed: {
			isVert(){
				return this.dir.toUpperCase() !== 'HORI'
			}
		},
		
		methods: {
			scrollDefaultClick(){
				this.$emit('click')
			},
			
			top(){
				event.stopPropagation()
				this.scroller.scrollTo(0, 0, 300)
			},
			
			loadPullDown(){
				BScroll.use(pullDownModule)
			},
			
			loadPullUp(){
				BScroll.use(pullUpModule)
			},
			
			initScroller(){
				this.pullDown && (this.loadPullDown())
				this.pullUp && (this.loadPullUp())
				setTimeout(async () => {
					const dom = document.getElementById(this.id)
					this.scroller = new BScroll(dom, {
						bounce: true,
						click: true,
						autoBlur: false,
						preventDefault: this.preventDefault,
						tap: true,
						preventDefaultException: {tagName: /input/i},
						pullDownRefresh: !!this.pullDown ? {
							threshold: 60,
							stop: 60
						} : false,
						pullUpLoad: !!this.pullUp ? {
							threshold: -100
						} : false,
						probeType: this.probeType,
						scrollX: this.dir.toUpperCase() == 'HORI',
						scrollY: this.dir.toUpperCase() !== 'HORI'
					})
					
					this.io = new LazyObserver({threshold: [1.0]})
					this.stickIo = new StickObserver(this.registStickContainer())
					
					this.pullDown && this.scroller.on('pullingDown', () => {
						this.$emit('finishPullDown', (text = '') => {
							this.pullDownFinish(text)
						})
					})
					this.pullUp && this.scroller.on('pullingUp', () => {
						this.pullUpText = '正在加载 ...'
						this.$emit('finishPullUp', (text = '') => {
							this.pullWidth = '100%'
							this.pullUpRemarkClass = 'pullUpRemarkDisplay'
							this.pullUpFinish(text)
						})
					})
					this.initEvents()
				}, 400)
			},
			
			initEvents(){
				const events = ['refresh', 'enable', 'disable', 'beforeScrollStart', 'scrollStart', 'scroll', 'scrollEnd', 'touchEnd', 'flick', 'destroy']
				events.forEach(eventName => {
					this.scroller.on(eventName, event => {
						if(eventName === 'scroll'){
							var activeElement = document.activeElement;
							if (activeElement &&
							    (activeElement.tagName === 'INPUT' ||
							        activeElement.tagName === 'TEXTAREA')) {
							    activeElement.setAttribute('readonly', 'readonly')
							}
							this.scrollerDefaultHandler(event)
							this.stickIo.action()
							window.activeEle = activeElement
						}
						if(eventName === 'beforeScrollStart'){
							
						}
						if(eventName === 'scrollEnd'){
							var activeElement = document.activeElement;
							if (activeElement &&
							    (activeElement.tagName === 'INPUT' ||
							        activeElement.tagName === 'TEXTAREA')) {
								if(activeElement.getAttribute('_readonly') == 'false' || activeElement.getAttribute('_readonly') == null){
									activeElement.removeAttribute('readonly')
								}
							}
						}
						this.$emit(eventName, event)
					})
				})
			},
			
			scrollerDefaultHandler(event){
				const {y} = event
				if(this.pullDown && (!this.pullDownLocker) && this.scroller.y >= 60){
					this.pullDownLocker = true
					this.pullDownText = '正在加载 ...'
				}
			},
			
			pullDownFinish(text){
				this.pullHeight = 80
				this.scroller.finishPullDown()
				this.pullDownLocker = false
				text && (this.pullDownFinishRemark = text)
				setTimeout(() => {
					this.pullHeight = '0'
					this.pullDownText = '下拉获取最新数据'
				}, 2000)
			},
			
			pullUpFinish(text){
				this.scroller.finishPullUp()
				text && (this.pullUpText = text)
				setTimeout(() => {
					this.pullUpText = '上拉获取下一页数据'
					this.pullUpRemarkClass = 'pullUpRemarkRemove'
					setTimeout(() => {
						this.pullWidth = '0'
					}, 300)
				}, 2000)
			},
			
			pullDownFinishError(){
				this.pullDownFinish('数据加载异常')
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.scroller-wrapper{
		position: relative;
		overflow: hidden;
		
		.scroll-top{
			position: absolute;
			bottom: 100px;
			right: 40px;
			border-radius: 100px;
			background: rgba(#000, .3);
			color: #fff;
		}
		
		.scroller-inner-wrapper{
			position: relative;
			
			.pull-down-wrapper{
				position: absolute;
				top: -120px;
				left: 0;
			}
			
			.pull-up-wrapper{
				position: relative;
				
				.pull-up-text{
					font-size: 24px;
					position: absolute;
					left: 0;
					top: 0;
				}
			}
			
			.pullDownRemark{
				overflow: hidden;
				transition: height .35s;
				
				.boxer{
					border-radius: 100px;
					background: rgba(#000, .15);
					color: #333;
					font-size: 24px;
					padding: 8px 24px;
				}
			}
			
			.pullUpRemark{
				overflow: hidden;
				transition: width .2s, opacity .3s;
				background: rgba(#000, .15);
				
				&.pullUpRemarkRemove{
					opacity: 0;
				}
				&.pullUpRemarkDisplay{
					opacity: 1.0;
				}
			}
		}
	}
</style>
